import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { createStructuredSelector } from 'reselect';
import {
  compose,
  lifecycle,
  withState,
  withHandlers,
} from 'react-recompose';
// components
import { LocalLoader } from '../../../components/local-loader';
import { openModal, closeModal } from '../../../components/modal/actions';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Box, Flex, FixedBox } from '../../../ui';
// hocs
import { withFilterTableList } from '../../../hocs';
// feature notification
import { MarkComponent } from './mark';
import { FooterComponent } from './footer';
import { NotificationHeader } from './header';
import { withDeleteNotifications } from '../hocs';
import { NotificationItem } from './notification';
import {
  selectItem,
  getItemListRequest,
  markAllAsReadRequest,
  deleteAllNotifications,
  deleteSelectedNotifications,
} from '../actions';
import {
  makeSelectWsCount,
  makeSelectItemList,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectUnreadCount,
} from '../selectors';
//////////////////////////////////////////////////

const enhance = compose(
  withState('allRead', 'setRead', {}),
  withState('closeLoader', 'showLoader', true),
  withDeleteNotifications,
  withHandlers({
    handlerOnEnter: (props) => () => {
      if (R.gt(props.totalCount, props.pagination.offset)) {
        props.getItemListRequest(true);
      }
    },
    handleRead: (props) => (entity) => {
      const data = {
        guids: R.of(Array, entity.mainGuid),
        read: true,
      };
      if (G.isFalse(entity.read)) {
        props.markAllAsReadRequest(data);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      if (G.isNilOrEmpty(this.props.notificationList)) {
        this.props.getItemListRequest(true);
        this.props.showLoader(false);
      }
    },
  }),
);

const renderNotificationItem = (props) => {
  const { handleRead, selectItem, onHidePopup, notificationList, filteredTableList } = props;

  if (G.isNotNilAndNotEmpty(notificationList)) {
    return filteredTableList.map(
      (item, key) => (
        <NotificationItem
          {...item}
          key={key}
          check={selectItem}
          withCheckbox={true}
          readAction={handleRead}
          actionHide={onHidePopup}
        />
      ));
  }
};

export const NotificationComponent = withFilterTableList(
  'searchString',
  'notificationList',
  ['notificationList'],
  {
    joiner: '',
    omitFields: [
      'guid',
      'version',
      'mainGuid',
      'selected',
      'objectGuid',
      'alarmEnabled',
      'lastModifiedBy',
      'triggeredValue',
      'lastModifiedDate',
    ],
    withoutValues: [null, undefined, ''],
  },
)((props) => {
  const {
    loading,
    wsCount,
    totalCount,
    pagination,
    selectItem,
    unreadCount,
    onHidePopup,
    handlerOnEnter,
    notificationList,
    markAllAsReadRequest,
    handleChangeFilterInput,
    handleDeleteAllNotifications,
    handleDeleteSelectedNotifications,
  } = props;

  return (
    <FixedBox
      top={26}
      left='50%'
      zIndex={30}
      width='auto'
      height='auto'
      overflow='auto'
      maxWidth='95dvw'
      maxHeight='85dvh'
      borderRadius={15}
      transform='translate(-50%)'
      boxShadow='2px 3px 30px 0px #545454'
      background={G.getTheme('colors.light.mainLight')}
    >
      {
        G.ifElse(
          G.isNilOrEmpty(notificationList),
          <LocalLoader width={700} minHeight={60} height='max-content' localLoaderOpen={loading}>
            <Flex
              py={50}
              width='100%'
              fontSize={36}
              justifyContent='center'
              color={G.getTheme('colors.light.middleGrey')}
            >
              {G.getWindowLocale('titles:empty-list', 'Empty List')}
            </Flex>
          </LocalLoader>,
          <Box minWidth={700}>
            <NotificationHeader onHidePopup={onHidePopup} handleChangeFilter={handleChangeFilterInput} />
            <MarkComponent
              selectAll={selectItem}
              actionRead={markAllAsReadRequest}
              check={G.isAllChecked(R.values(notificationList))}
              handleDeleteAllNotifications={handleDeleteAllNotifications}
              handleDeleteSelectedNotifications={handleDeleteSelectedNotifications}
            />
            <Flex
              p='5px'
              gap='3px'
              bg='white'
              width='100%'
              maxHeight={300}
              overflowY='auto'
              height='max-content'
              flexDirection='column'
              alignItems='flex-start'
              borderBottom='1px solid'
              borderColor={G.getTheme('colors.borderGray')}
            >
              {renderNotificationItem(props)}
              {
                R.gt(totalCount, pagination.offset) &&
                <Waypoint onEnter={handlerOnEnter} />
              }
            </Flex>
            <FooterComponent totalCount={wsCount} actionHide={onHidePopup} unreadCount={unreadCount} />
          </Box>,
        )
      }
    </FixedBox>
  );
});

const mapStateToProps = (state) => createStructuredSelector({
  wsCount: makeSelectWsCount(state),
  loading: makeSelectListLoading(state),
  pagination: makeSelectPagination(state),
  totalCount: makeSelectTotalCount(state),
  unreadCount: makeSelectUnreadCount(state),
  notificationList: makeSelectItemList(state),
});

export default connect(mapStateToProps, {
  openModal,
  closeModal,
  selectItem,
  getItemListRequest,
  markAllAsReadRequest,
  deleteAllNotifications,
  deleteSelectedNotifications,
})(enhance(NotificationComponent));
